import {CtModelRouteData} from "@ctsolution/ct-framework";

export const CompanyInformationRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("companyinformation");
